<template>
    <div class="learnlistBox">
        <div v-if="showLoading">
            <van-overlay :show="showLoading"/>
            <div class="loadinglist">
                <van-loading v-if="showLoading" size="24px" vertical>加载中...</van-loading>
            </div>
        </div>
        <div v-else class='learnlist'>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text=" 一 已经到底了，更多内容即将上线 一 "
                :immediate-check="false"
                ref="list"
                @load="onLoad"
                v-if="liveList && liveList.length"
            >
                <ul >
                    <li v-for="(item,index) in liveList" :key="index" @click="toexamDetial(item)">
                        <div class="learning-list-left">
                            <img class="learning-list-left-img" :src="item.propagatePic||'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/scss/live-pic.png'" alt="">
                        </div>
                        <div class="learning-list-right">
                            <h4>{{item.title}}</h4>
                            <p class="learning-list-right-time learning-list-right-time1">
                                {{formatTime(item.beginTime)}} - {{formatTime(item.planEndTime)}}
                            </p>
                            <p class="learning-list-right-time learning-list-right-time1" >
                                来源：{{item.sourceName}}
                            </p>
                        </div>
                        <span class="icon_suo" v-show="item.isLocked">
                            <svg-icon icon-class="lock" class-name="lock-icon"></svg-icon>
                        </span>
                    </li>
                </ul>
            </van-list>
            <div class="noContent" v-else>
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/learning/noContent.png"/>
                <p class="trainging-noContent">您还没有学习内容</p>
            </div>
        </div>
        <div v-show="false" ref="audioRef">音频</div>
    </div>

</template>

<script>
import $ from "jquery";
import { goLiveHome } from '../../../utils/livePlatform'
export default {
    name:'live',
    data () {
        return {
            showLoading: true,
            loading:false,
            finished:false,
            liveparam: {
                pageNum: 1,
                pageSize:10,
            },
            liveList: [],
            total: 0,
        };
    },
    components: {
    },
    methods: {
        /**
         * 上拉加载
         */
        onLoad() {
            this.liveparam.pageNum = this.liveparam.pageNum*1 + 1
            this.getDataList('reachBottom')
        },
        formatTime(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.')+' '+val.split(' ')[1].split(':').slice(0,2).join(':')
            }
        },
        toexamDetial(item) {

            if(item.isLocked){
                this.$toast({
                    message:`该直播未开启，开启条件为前面的课程学习进度达到 ${item.lockCourseRate}%`,
                    duration: 1000,
                });
                if(item.lockExamCondition){
                    this.$toast({
                        message:'该直播未开启，开启条件为前面的考试得分及格',
                        duration: 2000,
                    });
                }
            }else {
                if(item.status === 0){
                  this.$toast({
                      message:'直播未开始！',
                      duration: 2000,
                  });
                }else if(item.status === 1){
                  // 1 、腾讯TRTC 2、百家云 3、即构 4、百家云-自定义 5、百家云-OBS 6、cc视频
                  // this.$api.live.getBjyPlayUrl({liveCourseId: item.liveId}).then(async (resB) => {
                  //   if(resB.data.roomStatus==1){ // 腾讯
                  //     goLiveHome(this, item.liveId)
                  //     // this.$api.live.audienceEnterRoom({id: item.liveId}).then(async (res) => {
                  //     //   if (res.success) {
                  //     //     let u = navigator.userAgent;
                  //     //     let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                  //     //     let ua = window.navigator.userAgent.toLowerCase();
                  //         // if (isiOS && ua.match(/MicroMessenger/i) == 'micromessenger') {
                  //         //   this.$router.push({
                  //         //     path: '/liveSkip',
                  //         //   })
                  //         // } else {
                  //           // this.$router.push({
                  //           //   path: '/watchLive',
                  //           //   query:{
                  //           //     roomId: item.liveId,
                  //           //     type: 1,
                  //           //     from: 'list'
                  //           //   }
                  //           // })
                  //         // }
                  //       // }
                  //     // });
                  //   }else if(resB.data.roomStatus==2 || resB.data.roomStatus==5){ // 百家云
                  //     this.$router.push({
                  //       path: '/bjyStudent',
                  //       query: {
                  //         contentId: item.liveId
                  //       }
                  //     })
                  //   }else if(resB.data.roomStatus==4){ // 百家云自定义
                  //     if(!item.isReplay){
                  //       goLiveHome(this, item.liveId)
                  //       // this.$api.live.audienceEnterRoom({id: item.liveId}).then(async (res) => {
                  //       //   if (res.success) {
                  //           // this.$router.push({
                  //           //   path: '/bjyCustomStudent',
                  //           //   query: {
                  //           //       roomId: resB.data.room_id
                  //           //   }
                  //           // })
                  //       //   }
                  //       // })
                  //     }else{
                  //       goLiveHome(this, item.liveId)
                  //       // this.$router.push({
                  //       //     path: '/bjyLivePlayBack',
                  //       //     query: {
                  //       //       contentId: item.liveId
                  //       //     }
                  //       // })
                  //     }
                  //   }
                  // });

                    goLiveHome(this, item.liveId,item)



                }else if(item.status === 2){
                    if (!item.isReplay && !item.isRecord) {
                        this.$toast({
                            message:'直播已结束！',
                            duration: 3000,
                        });

                    } else if (item.isLiveReplay && item.isRecord) {
                        goLiveHome(this, item.liveId,item)
                    } else{
                        this.$toast({
                            message:'直播已结束！',
                            duration: 3000,
                        });
                    }

                }


            }
        },
        selectcheck(value){
            this.liveparam={
                pageNum: 1,
                pageSize: 10,
            };
            this.getDataList();
        },
        getDataList(type) {
            let params = this.liveparam;
            this.$api.live
                .getDataList({ params })
                .then(({ data }) => {
                    this.showLoading = false;
                    if(data){
                        if (type === "reachBottom") {
                            this.liveList = this.liveList.concat(data.list);
                        } else {
                            this.liveList = data.list || [];
                        }
                        this.total = data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        this.finished = data.isLastPage;
                    }

                });
        },

    },

    mounted(){

    },
}

</script>
<style lang='less'>
@import '../css/learnlist.less';
</style>
